import { authenticatedFetch } from '../utils/authenticatedFetch';
import { configs } from '../configs';

export type TranscriptionModel = 'gpt-4o-mini-transcribe' | 'whisper-large-v3';

export interface TranscriptionRequest {
  audioBlob: Blob;
  model?: TranscriptionModel;
}

export interface TranscriptionResponse {
  text: string;
  model: string;
}

class VoiceTranscriptionService {
  private baseUrl = `${configs.apiRoot}/assistant`;

  /**
   * Transcribe audio to text using the specified model
   */
  async transcribe(
    request: TranscriptionRequest
  ): Promise<TranscriptionResponse> {
    const formData = new FormData();
    formData.append('audio', request.audioBlob, 'audio.webm');
    if (request.model) {
      formData.append('model', request.model);
    }

    const response = await authenticatedFetch(`${this.baseUrl}/transcribe`, {
      method: 'POST',
      body: formData,
      // Don't set Content-Type header, let browser set it with boundary for FormData
    });

    if (!response.ok) {
      // Try to get error message from response body
      let errorMessage = `Transcription failed: ${response.status} ${response.statusText}`;
      try {
        const errorData = await response.json();
        if (errorData.message) {
          errorMessage = errorData.message;
        } else if (errorData.error) {
          errorMessage = errorData.error;
        }
      } catch (e) {
        // If JSON parsing fails, use default message
      }
      console.error('[VoiceTranscription] API error:', {
        status: response.status,
        statusText: response.statusText,
        errorMessage,
      });
      throw new Error(errorMessage);
    }

    return response.json();
  }
}

export const voiceTranscriptionService = new VoiceTranscriptionService();

